import { Area, Point } from '../../type/common.interface';

// 获取点在区域内的比例
export function getRatioInArea(point: Point, area: Area): [number, number] {
    const { x, y } = point;
    const { width, height } = area;

    const xRatio = x / width;
    const yRatio = y / height;

    return [xRatio, yRatio];
}
